import React from "react";
import moment from "moment";

class TableComponent extends React.Component {
  render() {


    const {date,fields,data} = this.props
    if(fields.length === 0){
      return (
        <div></div>
      );
    }
    let count = data.length;
    return (
      <div>
        <table style={{width: '100%'}}>
          <thead>
            <th>
              <h4 style={{textAlign:'right'}}>COLUSA COMERCIAL</h4>
              <p style={{textAlign:'right'}}>{date}</p>
            </th>
            <th style={{visibility:'hidden'}}>------------------</th>
            <th>
              <h3 style={{fontWeight:'bold',textAlign:'center'}}>BITACORA DE SALIDA</h3>
            </th>
          </thead>
        </table>
        <table style={{width: '100%'}}>
        <thead>
            <th style={{width:' 25px',visibility:'hidden'}}><p>Oculto</p></th>
            <th style={{textAlign:'left'}}>
              <p><b>Asesor:</b></p>
              <p><b>Día de Visita:</b></p>
            </th>
            <th style={{textAlign:'left'}}>
              <p>{fields[0].var}</p>
              <p>{fields[1].var}</p>
            </th>
            <th style={{textAlign:'left'}}>
              <p><b>Día de Visita2:</b></p>
              <p><b>Fecha Bitacora:</b></p>
            </th>
            <th style={{textAlign:'left'}}>
              <p>{fields[2].var}</p>
              <p>{date}</p>
            </th>
            <th style={{textAlign:'right'}}>
              <p><b style={{textAlign:'left'}}>Num de Documentos:</b></p>
              <p style={{visibility:'hidden'}}><b style={{textAlign:'left'}}>Num de Documentos:</b></p>
            </th>
            <th style={{textAlign:'left'}}>
              <p>{count}</p>
              <p style={{visibility:'hidden'}}>32</p>
            </th>
            <th style={{width:' 25px',visibility:'hidden'}}><p>Oculto</p></th>
          </thead>
        </table>
        <br></br>
        <table style={{width: '100%', borderCollapse: 'collapse'}}>
          <tr style={{backgroundColor:'#bdbdbd',paddingTop: '12px', paddingBottom: '12px', textAlign: 'left', color: 'black'}}>
            <th style={{visibility:'hidden'}}>a</th>
            <th >Cliente</th>
            <th>Factura SAP</th>
            <th>Nombre</th>
            <th>F. Factura</th>
            <th>Vencimiento</th>
            <th>T. Factura</th>
            <th>Saldo P.</th>
           
            <th style={{visibility:'hidden'}}>a</th>
          </tr>
          
          { data.map((item, index) => {
             return (
                <tr>
                  <th style={{visibility:'hidden'}}>a</th>
                  <th>{item.Cliente}</th>
                  <th>{item.Documento}</th>
                  <th>{item.Nombre}</th>
                  <th>{moment(item.DocDate).utc().format('MM/DD/YYYY')}</th>
                  <th>{moment(item.DocDueDate).utc().format('MM/DD/YYYY')}</th>
                  <th>{item.DocTotal}</th>
                  <th>{item.Saldo}</th>
                
                  <th style={{visibility:'hidden'}}>a</th>
                </tr>
             );
           })
           } 
        </table>    
        <br></br>
        <table style={{width: '100%'}}>
          <thead>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{textAlign:'justify', paddingLeft:'20px', paddingRight:'20px'}}>
              YO___________________________________________________________________________, por mi propio derecho, declaro que recibo las facturas originales antes descritas y asumo la responsabilidad en el cumplimiento del cobro de las mismas obligandome a realizar el depósito a la cuenta de COLUSA SA DE CV el mismo día del cobro y en caso de no recuperar los saldos que representan las facturas, me obligo a regresar las originales a Administración el mismo día de recepción.
            </th>
            <th style={{visibility:'hidden'}}>a</th>
          </thead>
        </table>
        <br></br>
        <table style={{width: '100%'}}>
          <thead>
          <th style={{visibility:'hidden'}}>a</th>
            <th>Entrega</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th>Recibe</th>
            <th style={{visibility:'hidden'}}>a</th>
          </thead>
        </table>
        <br></br>
        <table style={{width: '100%'}}>
          <thead>
            <th style={{visibility:'hidden'}}>oculto</th>
            <th>________________________________________</th>
            <th style={{visibility:'hidden'}}>oculto</th>
            <th style={{visibility:'hidden'}}>oculto</th>
            <th style={{visibility:'hidden'}}>oculto</th>
            <th style={{visibility:'hidden'}}>oculto</th>
            <th>________________________________________</th>
            <th style={{visibility:'hidden'}}>oculto</th>
          </thead>
        </table>
        <table style={{width: '100%'}}>
          <tr>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{fontWeight:'bold'}}>Nombre y Firma</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{fontWeight:'bold'}}>Nombre y Firma</th>
            <th style={{visibility:'hidden'}}>a</th>
          </tr>
          <tr>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{fontWeight:'bold'}}>Liquidadora de Sucursal</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{fontWeight:'bold'}}>Asesor</th>
            <th style={{visibility:'hidden'}}>a</th>
          </tr>
        </table>  
      </div>
    );
  }
}

export default TableComponent;